import React, {createContext, useContext, useEffect, useState} from 'react';
import UserContext from '../common/UserContext';

// react router
import {useHistory} from 'react-router-dom';

// kendo
import {PanelBar, PanelBarItem} from '@progress/kendo-react-layout';
import {Grid, GridColumn} from '@progress/kendo-react-grid';
import {Button} from '@progress/kendo-react-buttons';
import {orderBy} from '@progress/kendo-data-query';

// multilingual
import {useLocalization} from '@progress/kendo-react-intl';
import {
    assignedHostsKey,
    assignMoreKey,
    hostIdKey,
    noLicensesPeriodKey,
    mainMessages
} from '../../assets/text/MultilingualText.js';

// context to store popover reference, when to show, and which popover to show
export const PopoverContext = createContext({
    onMouseOver: () => null,
});

const ProductPanelBars = (props) => {
    const {
        fsaID,
        fsaStatus,
        groupByProducts,
        rowRender,
        isLoading
    } = props
    let history = useHistory();
    const {siteLanguageDefault} = useContext(UserContext);
    const localization = useLocalization();

    const [items, setItems] = useState(groupByProducts)
    useEffect(() => {
        setItems(JSON.parse(JSON.stringify(groupByProducts)));
    }, [groupByProducts]);

    return (
        <>
            {items.map((item, index) => {
                return (
                    <PanelBar
                        key={index}
                        expanded={['.0']}
                        className={'ksm-panelbar-default'}
                    >
                        <PanelBarItem
                            title={
                                <div style={{
                                    display: 'flex',
                                    gap: '0.938rem'
                                }}>
                                    <div
                                        className={"k-h5"}
                                        style={{
                                            color: 'white',
                                            margin: '0',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            maxWidth: '85%',
                                        }}
                                    >
                                        {item.product_number} {item.description}
                                    </div>
                                    <div
                                        style={{
                                            fontSize: '1rem',
                                            fontWeight: '300',
                                            color: 'white',
                                            lineHeight: '1.5rem',
                                            whiteSpace: 'nowrap',
                                        }}
                                    >
                                        {item.assigned_products !== 0 && (
                                            <div>
                                                {item.assigned_products} {localization.toLanguageString(assignedHostsKey, mainMessages[siteLanguageDefault][assignedHostsKey])}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            }
                        >
                            <Grid
                                data={orderBy(item.products, [{
                                    field: "name",
                                    dir: "desc"
                                }])}
                                rowRender={rowRender}
                                scrollable={'none'}
                                sortable={false}
                            >
                                <GridColumn
                                    field="nameExcel"
                                    title={localization.toLanguageString(hostIdKey, mainMessages[siteLanguageDefault][hostIdKey])}
                                />
                            </Grid>
                        </PanelBarItem>
                    </PanelBar>
                )
            })}

            {items.length === 0 && !isLoading && (
                <>
                    <b style={{
                        color: "rgb(233, 0, 41)",
                    }}>
                        {localization.toLanguageString(noLicensesPeriodKey, mainMessages[siteLanguageDefault][noLicensesPeriodKey])}
                    </b>
                    <br/>
                    <br/>
                </>
            )}

            {fsaStatus.toLowerCase() !== 'expired' && (
                <Button
                    themeColor={"primary"}
                    size={"large"}
                    fillMode={"solid"}
                    rounded={"small"}
                    onClick={() => {
                        history.push('/fsa-request-license?fsa_id=' + fsaID);
                    }}
                >
                    {localization.toLanguageString(assignMoreKey, mainMessages[siteLanguageDefault][assignMoreKey])}
                </Button>
            )}
        </>
    )
}

export default ProductPanelBars;